import { Component } from '@angular/core';
import { getSupportEmail } from 'src/app/shared/utils/support-email';

/** "What is an authenticator code?" — opened from the Authenticator Code field on the login page. */
@Component({
  standalone: false,
  selector: 'cms-authenticator-code-info',
  templateUrl: './authenticator-code-info.component.html',
  styleUrls: ['./authenticator-code-info.component.scss'],
})
export class AuthenticatorCodeInfoComponent {
  readonly supportEmail = getSupportEmail();
}
